<template>
	<section :class="['block-wrapper graph-wrapper', componentClass, colorMode, {visible: visible, ready: ready}]">
		<div class="row">
			<div class="columns small-12">
				<chart-line :data="data.graph" :ready="ready"></chart-line>
			</div>
		</div>
	</section>
</template>


<script>
import BaseBlock from './Base'
import ChartLine from './graph/Line'

export default {
	extends: BaseBlock,
	data() {
		return {
			defaultColorMode: 'dark',
			componentClass: 'graph-line',
		}
	},
	computed: {
		colorMode() {
			if (typeof this.data.theme !== 'undefined' && this.data.theme !== '') return this.data.theme;
			return this.defaultColorMode;
		}
	},
	components: {
		ChartLine
	}
}
</script>